// extracted by mini-css-extract-plugin
export default {"myWork":"MyWork_myWork__gauDp","overlayName":"MyWork_overlayName__FnLiZ"};